import React, { FC, ReactNode } from 'react';
import { cn } from '@thingslog/ui-components';

interface PortalToolbarProps {
  children: ReactNode;
  actions?: ReactNode;
  className?: string;
}

export const PortalToolbar: FC<PortalToolbarProps> = ({
  children,
  actions,
  className,
}: PortalToolbarProps) => {
  return (
    <section
      className={cn(
        'mb-3 flex flex-col gap-2 xl:flex-row xl:items-center xl:justify-between',
        className
      )}
    >
      <div className="flex min-w-0 flex-wrap items-center gap-2">{children}</div>
      {actions && <div className="flex min-w-0 flex-wrap items-center gap-2">{actions}</div>}
    </section>
  );
};
